import { ConversationAdapter, Message } from '../contexts/ConversationContext';
import {
  sendAdminChatMessage,
  getAdminChatMessages,
  AdminChatResponse,
} from '../services/adminChatService';
import { v4 as uuidv4 } from 'uuid';

export type ToolCallHandler = (toolCalls: AdminChatResponse['tool_calls']) => void;

export class AdminChatAdapter implements ConversationAdapter {
  private onToolCalls?: ToolCallHandler;

  constructor(onToolCalls?: ToolCallHandler) {
    this.onToolCalls = onToolCalls;
  }

  async initialize(): Promise<void> {
    // No initialization needed — session is created server-side on first message
  }

  async getMessages(): Promise<Message[]> {
    try {
      const data = await getAdminChatMessages();
      return data.messages
        .filter((m) => m.role === 'user' || m.role === 'assistant')
        .map((m) => ({
          id: uuidv4(),
          content: m.content || '',
          role: m.role as Message['role'],
          timestamp: new Date().toISOString(),
          metadata: m.tool_calls ? { tool_calls: m.tool_calls } : undefined,
        }));
    } catch (error) {
      console.error('Error fetching admin chat messages:', error);
      return [];
    }
  }

  async sendMessage(
    _sessionId: string,
    content: string,
    metadata?: Record<string, any>,
  ): Promise<Message> {
    const response = await sendAdminChatMessage(content, metadata?.model_id);

    // Notify context panel of tool calls
    if (this.onToolCalls && response.tool_calls?.length > 0) {
      this.onToolCalls(response.tool_calls);
    }

    return {
      id: uuidv4(),
      content: response.content,
      role: 'assistant',
      timestamp: new Date().toISOString(),
      metadata: {
        tool_calls: response.tool_calls,
        session_id: response.session_id,
      },
    };
  }
}
